import React from 'react';

import { TransitionProps } from '@mui/material/transitions/transition';
import { Box, Slide, Stack, Dialog, Button, useTheme } from '@mui/material';

import { useSendNotesBottomsheet } from './send-notes-bottomsheet.hook'

export interface SendNotesBottomsheetProps {
}

const Transition = React.forwardRef((
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) => <Slide direction="up" ref={ref} {...props} />);

export default function SendNotesBottomsheet(Props: SendNotesBottomsheetProps) {
  const {
    openSendNotes,
    onClose,
    onClickButton
  } = useSendNotesBottomsheet();
  const theme = useTheme()
  return (
    <Dialog
      data-testid='sendNotesBottomsheet-render-test'
      open={openSendNotes}
      onClose={onClose}
      fullWidth
      TransitionComponent={Transition}
      sx={{
        '.MuiDialog-paper': {
          bottom: 0,
          position: 'absolute',
          mb: 0,
          width: '100%'
        },
        '.MuiPaper-rounded': {
          borderTopLeftRadius: '8px !important',
          borderTopRightRadius: '8px !important',
          borderBottomLeftRadius: '0px !important',
          borderBottomRightRadius: '0px !important',
        }
      }}
    >
      <Stack px={8} spacing={8} pt={12} pb={16} alignItems='center' >
        <Box
          height={4}
          width='15%'
          bgcolor={theme.palette.grey[500]}
          borderRadius={50}
          onClick={() => onClose()}
        />
        <Stack spacing={4} width='100%'>
          <Button variant='contained' color='secondary' onClick={() => onClickButton('prizor')}>
            Ganhar pontos e participar do sorteio
          </Button>
          <Button variant='contained' color='secondary' onClick={() => onClickButton('iris')}>
            Somente ganhar Pontos
          </Button>
        </Stack>
      </Stack>
    </Dialog>
  )
}
